import type { TemplateSummary } from "../../api/types";

/**
 * 1009 C 线:模板能力标签(模板卡 / 新建站点弹窗共用),让客户自己挑能用的模板。
 *  - 「带产品详情页」= 画像里有 `${product.*}` 动态节点(`dynamic`):发布前把产品同步到宿主,详情页由模板渲染;
 *  - 「新闻自动更新」= 模板含动态新闻列表(`articleList === true`):新闻舱发到官网的文章自动出现在新闻列表里。
 *    `false`(新闻页是静态卡片)不画标签,弹窗里另写一句提醒;`null` = 不知道,什么都不说。
 */
export type TemplateCapabilitySource = Pick<TemplateSummary, "dynamic"> &
  Partial<Pick<TemplateSummary, "articleList">>;

export const PRODUCT_DETAIL_LABEL = "带产品详情页";
export const NEWS_AUTO_LABEL = "新闻自动更新";
export const NO_NEWS_LIST_HINT =
  "这套模板的新闻页是静态卡片:新闻舱的文章发上去后在新闻列表里看不到,只能经链接访问。想让新闻自动更新,请选标「新闻自动更新」的模板。";

const CHIP_ON = "rounded bg-primary/10 px-1.5 py-0.5 text-primary";

export function TemplateCapabilityChips({ template }: { template: TemplateCapabilitySource }) {
  return (
    <>
      {template.dynamic && (
        <li className={CHIP_ON} title="发布前会先把产品同步到宿主,产品列表与详情页由模板渲染">
          {PRODUCT_DETAIL_LABEL}
        </li>
      )}
      {template.articleList === true && (
        <li className={CHIP_ON} title="新闻舱发到官网的文章会自动出现在新闻列表里">
          {NEWS_AUTO_LABEL}
        </li>
      )}
    </>
  );
}
